import React from "react";
import ReactDOM from "react-dom";
import Sidebar from "./Sidebar";
import ImageCarousel from "./ImageCarousel";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.css";
// import MenuIcon from '@material-ui/icons/Menu';
// import bg from "./assets/wine.png";
import { Helmet } from "react-helmet";
import { IconButton } from "@material-ui/core";
import InstagramIcon from '@material-ui/icons/Instagram';
import { useSpring, animated } from "react-spring";
import styled from "@emotion/styled/macro";
import beerTile from "./assets/beer-tile.png";
import StreetviewIcon from '@material-ui/icons/Streetview';
import {BrowserRouter as Router, Link, Route, Switch} from "react-router-dom";


/*

TODO
    * On hover-over beer tile: "Check out our imported beers"

*/


const TITLE = "Papa's Liquor";

const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) {
        newWindow.opener = null;
    }
}

function Greeting() {
    const props = useSpring({
        config: {duration: 500},
        opacity: 1,
        marginLeft: 0,
        from: {
            opacity: 0,
            marginLeft: -500
        }
    });

    return (
        <animated.div style={props}>
            WE'RE UNDER NEW MANAGEMENT!
        </animated.div>
    );
}

const BeerTile = styled.div({
    height: 10,
    backgroundImage: beerTile,
    backgroundSize: "cover"
});

function MobileLayout() {
    return (
        <div>
            <div className="background" style={{ 
                /* border: "2px solid red", */ 
                display: "flex", 
                flexDirection: "row" 
            }}>
                <div style={{
                    /* border: "2px solid red", */ 
                    /* marginTop: 50, */ 
                    /* marginLeft: 250, */ 
                    height: 500, 
                    width: "50%", 
                    color: "white", 
                    fontFamily: "Antonio-Regular", 
                    fontSize: 80, 
                    display: "flex", 
                    justifyContent: "center", 
                    alignItems: "center" 
                    /* marginLeft: 250 */
                }}>
                    <div style={{marginLeft: 180 }}>
                        <Greeting />
                    </div>
                </div>
            </div>

            <div style={{
                /* border: "2px solid red", */ 
                /* backgroundColor: "#1a1613", */ 
                backgroundColor: "#1f1b18", 
                /* marginTop: 50, */ 
                /* marginLeft: 50, */ 
                // width: "50%" 
                /* marginRight: 500 */
            }}>
                <ImageCarousel />
            </div>
        </div>
    );
}

function DesktopLayout() {
    return (
        <div>
            <div className="background" style={{ /* border: "2px solid red", */ display: "flex", flexDirection: "row" }}>
                <div style={{/* border: "2px solid red", */ /* marginTop: 50, */ /* marginLeft: 250, */ height: 500, width: "50%", color: "white", fontFamily: "Antonio-Regular", fontSize: 100, display: "flex", justifyContent: "center", alignItems: "center" /* marginLeft: 250 */}}>
                    <div style={{marginLeft: 100 }}>
                        <Greeting />
                    </div>
                </div>

                <div style={{/* border: "2px solid red", */ /* backgroundColor: "#1a1613", */ backgroundColor: "#1f1b18", /* marginTop: 50, */ /* marginLeft: 50, */ width: "50%" /* marginRight: 500 */}}>
                    <ImageCarousel />
                </div>
            </div>

            <div className="bottom">
                <div className="socialmedia">
                    <IconButton onClick={() => openInNewTab("https://www.instagram.com/papasliquorstore/")}>
                        <InstagramIcon style={{color: "#f0a742"}}/>
                    </IconButton>

                    <IconButton onClick={() => openInNewTab("https://www.google.com/maps/place/Papa's+Liquor/@38.9336261,-77.0750329,17z/data=!3m1!4b1!4m5!3m4!1s0x89b7c9d920a109ef:0xf3c21b3776dfcd8f!8m2!3d38.9336226!4d-77.0728393")}>
                        <StreetviewIcon style={{color: "#f0a742"}} />
                    </IconButton>
                </div>

                <div>
                    <BeerTile />
                </div>

            </div>
        </div>
    );
}

function Home() {
    if (window.innerWidth <= 800) {
        return (<MobileLayout />);
    }
    else {
        return (<DesktopLayout />);
    }
}

function About() {
    // const props = useSpring({
    //     config: { duration: 900 },
    //     opacity: 1,
    //     marginLeft: 300,
    //     from: {
    //         opacity: 0,
    //         marginLeft: -500
    //     }
    // });
    
    return (
        <div className="about">
            <p>We are a small family-owned wine and spirits store in the upper Georgetown area in Washington, D.C. We supply domestic and international wines, spirits, and beers, with a wide range of tequilas, scotches, single-malt whiskeys, and champagnes. We also serve cigarettes and other products. Soon, we plan on offering a delivery service for our customers' convenience.</p>

            <p>You can find us at:</p>

            <p>
                &emsp;&emsp;3703 Macomb St NW <br />
                &emsp;&emsp;Washington, DC 20016
            </p>

            <p>You can call us at:</p>

            <p>
                &emsp;&emsp;+1 (202) 237-1400
            </p>

            <p>Our hours of operation are:</p>

            <p>
                &emsp;&emsp;Sunday, Closed <br />
                &emsp;&emsp;Monday, 11AM–10PM <br />
                &emsp;&emsp;Tuesday, 11AM–10PM <br />
                &emsp;&emsp;Wednesday, 11AM–10PM <br />
                &emsp;&emsp;Thursday, 11AM–10PM <br />
                &emsp;&emsp;Friday, 11AM–11PM <br />
                &emsp;&emsp;Saturday, 11AM–11PM <br />
            </p>
        </div>
    );
}

// function Contact() {
//     return (
//         <div>
//             Hi
//         </div>
//     );
// }

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return(
            <div>
                <div>
                    <Helmet>
                        <title>{ TITLE }</title>
                    </Helmet>
                </div>
            
                <div style={{/* backgroundColor: "#1a1613" */ }}>

                    <div style={{/* border: "2px solid red", */ display: "flex", backgroundColor: "#27211d", flexDirection: "row" }}>
                        <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginLeft: 20 }}>
                            <Sidebar />
                        </div>

                        <div style={{color: "white", fontFamily: "Lobster-Regular", fontSize: 70, display: "flex", /* border: "2px solid red", */ justifyContent: "center", alignItems: "center", marginLeft: 550 }} onClick={() => {window.location.href=""}}>
                            <Link to="/">
                                Papa's Liquor
                            </Link>
                        </div>
                    </div>


                    <Switch>
                        <Route path="/about">
                            <About />
                        </Route>

                        {/* <Route path="/contact">
                            <Contact />
                        </Route> */}

                        <Route exact path="/">
                            <Home />
                        </Route>
                    </Switch>
                </div>
            </div>
        );
    }
}

ReactDOM.render(
    <Router><App /></Router>,
    document.getElementById("root")
);

// <link
//    rel="apple-touch-icon"
//    sizes="180x180"
//    href="%PUBLIC_URL%/wine-icon.png"
// />

// <div className="background">
//                         </div>

// <MenuIcon 
// style={{
//     fontSize: 40
// }}
// />
